import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Parte } from './partes.model';
import { PartesService } from './partes.service';
import { ActivatedRoute, Route } from '@angular/router';
import { Select2Data } from 'ng-select2-component';
import { ArbitrosService } from '../arbitros/arbitros.service';
import { getCurrentLanguage } from '../core/helpers/utils';

@Component({
  selector: 'app-new-parte',
  templateUrl: './new-parte.component.html',
  styleUrls: ['./new-parte.component.scss']
})
export class NewParteComponent implements OnInit {

  nacionalidades: Select2Data = [];

  currentLanguage: string = getCurrentLanguage();

  // Control de errores
  error: string = '';

  // Animación de loading
  loaded: boolean = false;

  @Output() changePartesView = new EventEmitter<string>();

  constructor(private partesService: PartesService,
    private route: ActivatedRoute,
    private arbitrosService: ArbitrosService
  ) { }

  model = {
    id: "",
    id_expediente: "",
    tipo_parte: "",
    cif: "",
    razon_social: "",
    direccion: "",
    codigo_postal: "",
    poblacion: "",
    provincia: "",
    nacionalidad: "",
    comentarios: "",
    impuesto_aplicable: "21",
    porcentaje_imputable: "100"
  }

  ngOnInit(): void {
    this.loadNacionalidades();
  }

  loadNacionalidades() {
    this.arbitrosService.getNacionalidades().subscribe({
      next: (data) => {

        // Procesamiento datos para Nacionalidades
        const dataNacionalidadesFromDB = data;
        const convertedNacionalidadesData = dataNacionalidadesFromDB.map(item => ({
          value: item.codigo_alfa2,
          label: item[this.currentLanguage]
        }));
        this.nacionalidades = convertedNacionalidadesData;
        this.loaded = true;
      },
      error: (error) => {
        console.error('Error loading nacionalidades:', error);
        this.error = error;
        this.loaded = false;
      }
    });
  }
  

  navigateToList(): void {
    this.changePartesView.emit('list'); // Emitir evento con el valor 'list'
  }

  onSubmit(form: NgForm) {
    const id = this.route.snapshot.paramMap.get('id');

    if (id !== null) {
        // Convertir los valores a decimal usando parseFloat
        const impuestoAplicable = parseFloat(
            typeof form.value.impuesto_aplicable === 'string'
                ? form.value.impuesto_aplicable.replace(',', '.')
                : form.value.impuesto_aplicable || '0'
        );

        const porcentajeImputable = parseFloat(
            typeof form.value.porcentaje_imputable === 'string'
                ? form.value.porcentaje_imputable.replace(',', '.')
                : form.value.porcentaje_imputable || '0'
        );

        const parte: Parte = {
            id_expediente: id,
            tipo_parte: form.value.tipo_parte,
            cif: form.value.cif,
            razon_social: form.value.razon_social,
            direccion: form.value.direccion,
            codigo_postal: form.value.codigo_postal,
            poblacion: form.value.poblacion,
            provincia: form.value.provincia,
            nacionalidad: form.value.nacionalidad,
            comentarios: form.value.comentarios,
            impuesto_aplicable: !isNaN(impuestoAplicable) ? impuestoAplicable.toString() : '0',
            porcentaje_imputable: !isNaN(porcentajeImputable) ? porcentajeImputable.toString() : '0'
        };
        this.partesService.newParte(parte)
            .subscribe(res => {
                this.navigateToList();
            },
            (error: any) => {
                console.error('Error creating new parte:', error);
            });
    }
}





}
